module.exports = __webpack_public_path__ + "img/logo.940b6b81.png";